export const RESTORE_TESTING_DATA = 'RESTORE_TESTING_DATA';
export const UPDATE_LAB_REQUEST_PROPERTY = 'UPDATE_LAB_REQUEST_PROPERTY';
export const LAB_REQUEST_LOADED = 'LAB_REQUEST_LOADED';
export const SET_INTEROPERABILITY_RESULT = 'SET_INTEROPERABILITY_RESULT';
export const SET_CONFORMANCE_RESULTS = 'SET_CONFORMANCE_RESULTS';
export const SET_INTEROPERABILITY_RESULT_FILE = 'SET_INTEROPERABILITY_RESULT_FILE';
export const UPDATE_EXPLANATION = 'UPDATE_EXPLANATION';
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS';
